import { render } from "./DisplayHeadingNode.vue?vue&type=template&id=0aaad028"
import script from "./DisplayHeadingNode.vue?vue&type=script&lang=js"
export * from "./DisplayHeadingNode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__